import React, { useState, useEffect, useRef } from 'react';

import Icon from '../../ui/icon/icon';

import './styles/snackbar.scss';

const SnackBar = ({ message, setSnackbarTxt, timeout }) => {
  const ref = useRef(null);
  const [didMount, setDidMount] = useState(false);

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (timeout && didMount) {
      const fadeTimer = setTimeout(() => {
        fade();
      }, 1000 * timeout);

      const resetTextTimer = setTimeout(() => {
        setSnackbarTxt('')
      }, 1000 * timeout + 500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(resetTextTimer);
      };
    }
  }, [didMount]);

  useEffect(() => {
    if (didMount) {
      const showTimer = setTimeout(() => {
        ref.current.classList.add('show');
      }, 1);

      return () => {
        clearTimeout(showTimer);
      };
    }
  }, [didMount]);

  useEffect(() => {
    if (timeout && didMount) {
      ref.current.style.opacity = '1';
    }
  }, [message]);

  function fade() {
    ref.current.style.transition = 'opacity .5s ease-out';
    ref.current.style.opacity = '0';
  }

  return (
    <div className="manual-snackbar" ref={ref}>
      <span>{message}</span>
      <span onClick={() => setSnackbarTxt('')}>
        <Icon iconName="x" size={10} />
      </span>
    </div>
  );
};

export default SnackBar;
